import { Collapse, type CollapseProps } from "antd";
import { SvgArrowDown, SvgArrowUp } from "components/svg";
import { env } from "env";
import { useCallback, useEffect, useState } from "react";
import { useGetTutorialsQuery } from "store/api";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

export const VideoPage: React.FC = () => {
  const { language } = useTranslation();
  const { network } = useSalesNetwork();
  const { data: TutorialData } = useGetTutorialsQuery(
    { lang: language || "", environnement_id: network?.id || "" },
    { skip: !language || !network }
  );
  const [currentVideo, setCurrentVideo] = useState<number[]>();

  const items: CollapseProps["items"] = TutorialData?.map((i: any) => ({
    key: i.id,
    label: i.category,
    children: (<>
      <picture
        data-ratio="16:9"
      >
        <video
          //data-position="absolute"
          src={`${env.api_url}/${i.video.filepath}`}
          //src="https://afdprojipacprd7000.azurefd.net/upload/314_Régler votre compte client.mp4"
          //autoPlay
          //muted
          loop
          //playsInline
          controls={true}
          data-object-fit="cover"
          data-height="fit"
          data-max-length="fit"
        ></video>
      </picture>
    </>),
    //showArrow: false,
  }));

  useEffect(() => {

    if (TutorialData && TutorialData.length > 0) {
      setCurrentVideo([TutorialData[0].id]);
    }
  }, [TutorialData])


  const onChange = useCallback((key: any) => {
    //debugger
    if (currentVideo) {
      if (key.length === 0) {
        setCurrentVideo([]);
      } else {
        key.map((k: any) => {
          if (k !== currentVideo) {
            setCurrentVideo([k]);
          }
        })
      }
    } else {
      setCurrentVideo([key[0]]); //key.length > 1 ? key.slice(1, 1) : key)
    }

  }, [setCurrentVideo, currentVideo]);


  const videoList = <group data-direction="column">
    <Collapse
      items={items}
      onChange={onChange}
      destroyOnHidden={true}
      {...(currentVideo ? { activeKey: currentVideo } : {})}
      expandIconPosition={"end"}
      expandIcon={({ isActive }) => (
        isActive ? <icon data-svg-size="70" data-min-length="70" data-svg-color="secondary"><SvgArrowUp /></icon> : <icon data-svg-size="70" data-min-length="70" data-svg-color="secondary"><SvgArrowDown/></icon>
      )}
    />
  </group>;


  return (
    <group>
      <group data-align="center" data-direction="column" data-gap="20">
        <group
          data-gap="40"
          //data-space-vertical="10"
          data-wrap="no"
          data-max-length="1440"
          data-adaptive="desktop"
        >
          {videoList}
        </group>

        <group
          data-gap="40"
          //data-space-vertical="10"
          data-wrap="no"
          data-max-length="1440"
          data-space-horizontal="20"
          data-adaptive="mobile"
        >
          {videoList}
        </group>
      </group>
    </group>
  );
};
